// extracted by mini-css-extract-plugin
export default {"LoaderWrapper":"Input_LoaderWrapper__G1aTw"};